import React, { memo } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

function JarIcon(props) {
	return (
		<SvgIcon viewBox="0 0 512 512" {...props}>
			<g>
				<g>
					<rect
						x="74.715"
						y="59.998"
						transform="matrix(0.9985 -0.0551 0.0551 0.9985 -3.7434 14.2189)"
						width="362.557"
						height="30.001"
					/>
				</g>
			</g>
			<g>
				<g>
					<polygon points="91,0 91,39.047 421,20.815 421,0 		" />
				</g>
			</g>
			<g>
				<g>
					<path d="M172.243,332H151v30h32h6.013C181.593,353.293,175.838,343.128,172.243,332z" />
				</g>
			</g>
			<g>
				<g>
					<path d="M338.673,404.094c-0.672-0.586-1.569-1.102-2.69-1.55v6.199c1.345-0.111,2.297-0.39,2.858-0.838
			c0.56-0.445,0.841-1.031,0.841-1.758C339.682,405.365,339.346,404.681,338.673,404.094z" />
				</g>
			</g>
			<g>
				<g>
					<path d="M245,394c0-0.563,0.011-1.123,0.021-1.684c-0.767-0.096-1.531-0.201-2.292-0.316H183h-62v30h128.568
			C246.607,413.201,245,403.785,245,394z" />
				</g>
			</g>
			<g>
				<g>
					<path d="M328.251,380.178c0,0.838,0.28,1.523,0.841,2.052c0.56,0.531,1.4,1.02,2.521,1.466v-6.367
			C329.371,377.609,328.251,378.558,328.251,380.178z" />
				</g>
			</g>
			<g>
				<g>
					<path d="M421,120.211v-9.258L257.249,120H96c-35.841,0-65,29.159-65,65v262c0,35.841,29.159,65,65,65h22v-60H91v-90h30v-60h47.057
			c1.588-47.139,40.424-85,87.943-85c48.523,0,88,39.477,88,88c0,0.564-0.028,1.121-0.039,1.682
			C387.331,312.094,421,349.188,421,394c0,48.523-39.477,88-88,88c-13.997,0-27.239-3.291-39-9.13V512h122c35.841,0,65-29.159,65-65
			V185C481,150.843,454.511,122.776,421,120.211z" />
				</g>
			</g>
			<g>
				<g>
					<path d="M256,247c-31.981,0-58,26.019-58,58c0,28.337,20.432,51.976,47.333,57h5.691c10.57-26.983,34.096-47.515,62.884-53.908
			c0.055-1.025,0.092-2.054,0.092-3.092C314,273.019,287.981,247,256,247z" />
				</g>
			</g>
			<g>
				<g>
					<path d="M333,336c-31.981,0-58,26.019-58,58c0,31.981,26.019,58,58,58c31.981,0,58-26.019,58-58C391,362.019,364.981,336,333,336z
			 M355.609,412.975c-1.149,2.318-2.662,4.217-4.539,5.697c-1.878,1.48-4.022,2.597-6.43,3.351c-2.41,0.754-4.904,1.215-7.481,1.382
			v10.137h-6.724v-10.304c-3.865-0.336-7.704-1.09-11.514-2.263c-3.811-1.173-7.229-2.652-10.254-4.44l7.06-14.326
			c1.513,0.951,3.138,1.843,4.875,2.681c1.456,0.727,3.152,1.439,5.085,2.136c1.934,0.699,3.909,1.187,5.926,1.466v-7.372
			c-1.738-0.447-3.475-0.977-5.211-1.592c-2.635-0.893-4.904-1.856-6.808-2.89c-1.905-1.033-3.475-2.206-4.707-3.518
			c-1.234-1.312-2.143-2.807-2.732-4.482c-0.588-1.676-0.882-3.602-0.882-5.78c0-3.016,0.504-5.682,1.513-8.001
			c1.008-2.317,2.381-4.314,4.118-5.99c1.736-1.676,3.768-3.016,6.094-4.021c2.325-1.005,4.804-1.647,7.439-1.927v-8.461h6.724
			v8.545c1.849,0.224,3.642,0.559,5.379,1.005c1.736,0.448,3.404,0.963,5.001,1.55c1.597,0.586,3.095,1.202,4.497,1.843
			c1.4,0.643,2.69,1.244,3.866,1.801l-7.06,13.488c-1.233-0.781-2.578-1.508-4.035-2.178c-1.233-0.614-2.62-1.186-4.161-1.717
			c-1.542-0.53-3.097-0.935-4.665-1.215v7.54c0.504,0.113,1.036,0.266,1.597,0.461c0.56,0.196,1.148,0.377,1.765,0.545
			c2.745,0.837,5.225,1.759,7.438,2.764c2.213,1.005,4.104,2.193,5.674,3.56c1.568,1.369,2.774,3.03,3.614,4.985
			c0.841,1.956,1.261,4.329,1.261,7.121C357.332,407.852,356.757,410.658,355.609,412.975z" />
				</g>
			</g>
			<g>
				<g>
					<rect x="148" y="452" width="116" height="60" />
				</g>
			</g>
			<g />
			<g />
			<g />
			<g />
			<g />
			<g />
			<g />
			<g />
			<g />
			<g />
			<g />
			<g />
			<g />
			<g />
			<g />
		</SvgIcon>
	);
}

export default memo(JarIcon);
